<template>
    <BlogBodyComponent />
</template>

<script>
// import HeaderComponentVue from '../HeaderComponent.vue';
import BlogBodyComponent from './BlogBodyComponent.vue'

export default {
    name: 'BlogComponent',
    components: {
        // HeaderComponentVue,
        BlogBodyComponent,
    }
}
</script>